export const postNeedHeaderArr = [
  { title: 'Post Name', },
  { title: 'Private Group (Y/N)', },
  { title: 'Poster Email', },
  { title: 'Poster Company Name', },
  { title: 'Req Del/PU Date', },
  { title: 'Total Bids Received', },
  { title: 'Post Status', },
  { title: 'Bid Status', },
  { title: 'Time Clock of Bid End Time', },
  { title: 'Account Rep', },
  { title: 'Comments', },
  { title: '', }
];

export const postInventoryHeaderArr = [
  { title: 'Post Name', },
  { title: 'Private Group (Y/N)', },
  { title: 'Poster Email', },
  { title: 'Poster Company Name', },
  { title: 'Total Offers Received', },
  { title: 'Post Status', },
  { title: 'Offer Status', },
  { title: 'Time Clock of Bid End Time', },
  { title: 'Account Rep', },
  { title: 'Comments', },
  { title: '', }
];

export const needsColumns = [
  { id: 'PostName', displayName: 'Post Name' },
  { id: 'PosterEmail', displayName: 'Poster Email ID' },
  { id: 'PosterCompanyName', displayName: 'Poster Company Name' },
  { id: 'PrivateGroup', displayName: 'Private Group(Y/N)' },
  { id: 'Deliveryaddress', displayName: 'Delivery Address' },
  { id: 'City', displayName: 'City' },
  { id: 'State', displayName: 'State' },
  { id: 'Zip', displayName: 'Zip' },
  { id: 'Contactno', displayName: 'Contact No.' },
  { id: 'QuantityOrderType', displayName: 'Quantity - OrderType' },
  { id: 'Price', displayName: 'Price' },
  { id: 'ReqDelPUDate', displayName: 'Req Del/PU Date' },
  { id: 'TotalBidsReceived', displayName: 'Total Bids Received' },
  { id: 'TimeClockofBidEndTime', displayName: 'Bid Time End' },
  { id: 'Comments', displayName: 'Post Comment' },
  { id: 'AccountRep', displayName: 'Poster Account Rep' },

  { id: 'BidderEmail', displayName: 'Bidder Email' },
  { id: 'BidderCompanyname', displayName: 'Bidder Company Name' },
  { id: 'BidderContactno', displayName: 'Bidder Contact No.' },
  { id: 'BidderQuantity', displayName: 'Bidder (Quantity - OrderType) @Price' },
  { id: 'BidderDate', displayName: 'Bidder DU/PU Date' },
  { id: 'BidderDeliveryPUaddress', displayName: 'Bidder DU/PU Address' },

  { id: 'PostStatus', displayName: 'Post Status' },
  { id: 'BidStatus', displayName: 'Most Recent Bid Status' },

  { id: 'BidderAccountRep', displayName: 'Bidder Account Rep' },
  { id: 'BidderComment', displayName: 'Bidder Comment' },
];

export const invColumns = [
  { id: 'PostName', displayName: 'Post Name' },
  { id: 'PosterEmail', displayName: 'Poster Email' },
  { id: 'PosterCompanyName', displayName: 'Poster Company Name' },
  { id: 'PrivateGroup', displayName: 'Private Group(Y/N)' },
  { id: 'Deliveryaddress', displayName: 'Delivery Address' },

  { id: 'City', displayName: 'City' },
  { id: 'State', displayName: 'State' },
  { id: 'Zip', displayName: 'Zip' },
  { id: 'Contactno', displayName: 'Contact No' },
  { id: 'QuantityOrderType', displayName: 'Quantity - OrderType' },

  { id: 'Price', displayName: 'Price' },
  { id: 'TotalOffersReceived', displayName: 'Total Offers Received' },
  { id: 'TimeClockofBidEndTime', displayName: 'Bid Time End' },
  { id: 'Comments', displayName: 'Post Comment' },
  { id: 'AccountRep', displayName: 'Poster Account Rep' },

  { id: 'BidderEmail', displayName: 'Bidder Email' },
  { id: 'BidderCompanyname', displayName: 'Bidder Company Name' },
  { id: 'BidderContactno', displayName: 'Bidder Contact No.' },
  { id: 'BidderQuantity', displayName: 'Bidder (Quantity - OrderType) @Price' },
  { id: 'BidderDate', displayName: 'Bidder DU/PU Date' },
  { id: 'BidderDeliveryPUaddress', displayName: 'Bidder DU/PU Address' },

  { id: 'PostStatus', displayName: 'Post Status' },
  { id: 'OfferStatus', displayName: 'Most Recent Offer Status' },

  { id: 'BidderAccountRep', displayName: 'Bidder Account Rep' },
  { id: 'BidderComment', displayName: 'Bidder Comment' },
];

export const postStatusList = ['ALL', 'ACTIVE', "EXPIRED", 'NO ACTION', 'ORDER CREATED']
